module.exports = __webpack_public_path__ + "static/media/car-pet.cf1f091d.svg";